import { CancelOutlined, Edit, GetApp } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { format, isSameDay, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { MaterialReactTable } from "material-react-table";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { auditarExportacion, CODIGO_AUDITORIA } from "../../../../actions/audit";
import { getFormatoFechaExportacion } from "../../../../utils/datetimeUtils";
import { downloadCsv } from "../../../../utils/filesUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";
const ConnectivityErrorsTable = ({
  data,
  namesArts,
  loading,
  title,
  noRefresh,
  fetchData,
  handleChangeTime,
  handleDesestimar,
  handleOpenEditForm,
}) => {
  const dispatch = useDispatch();
  const time = useSelector(
    (state) => state.connectivityResponse.connectivityErrors.time,
  );
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
  const columns = [
    {
      header: "Art",
      accessorKey: "art",
      enableColumnActions: false,
      enableFiltering: true,
      size: 100,
      muiTableBodyCellProps: {
        sx: {
          fontSize: 12,
        },
      },
      maxSize: 100,
      Cell: ({ row }) => row.original.art.toUpperCase(),
      Filter: ({ column }) => (
        <Autocomplete
          multiple
          options={Object.values(namesArts ?? [])}
          value={column.getFilterValue() || []}
          onChange={(event, newValue) =>
            column.setFilterValue(newValue.length ? newValue : undefined)
          }
          getOptionLabel={(option) => option.nombreCorto}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  height: 35,
                  minHeight: "unset",
                },
                "& .MuiInputAdornment-root": {
                  height: 30,
                },
                "& .MuiOutlinedInput-input ": {
                  padding: "5px 10px",
                  fontSize: "0.875rem",
                },
                "& .MuiChip-root": {
                  height: 20,
                  fontSize: "0.75rem",
                  margin: "2px",
                },
                "& .MuiAutocomplete-input": {
                  padding: "5px 10px",
                  fontSize: "0.875rem",
                },
                "& .MuiAutocomplete-popover": {
                  maxHeight: 250,
                  overflowY: "auto",
                },
              }}
            />
          )}
          disableCloseOnSelect
          renderOption={(props, option, { selected }) => (
            <ListItem {...props} key={option.id}>
              <Checkbox
                size="sm"
                checked={selected}
                sx={{
                  padding: 0,
                  margin: 0,
                  marginRight: 0.5,
                  marginLeft: -1,
                }}
              />
              <Typography variant="body2">{option.nombreCorto}</Typography>
            </ListItem>
          )}
        />
      ),
      filterFn: (row, id, filterValue) => {
        if (!filterValue || filterValue.length === 0) return true;
        const rowValue = row.original.mlCloudCoreArtId;
        return filterValue.some((value) => rowValue === value.id);
      },
    },
    {
      header: "Fecha Formulario",
      accessorKey: "fechaFormulario",

      enableColumnActions: false,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const cellValue = row.getValue(columnId);
        if (!cellValue) return false;
        return isSameDay(parseISO(cellValue), filterValue);
      },
      Cell: ({ row }) =>
        row.original.fechaFormulario
          ? format(parseISO(row.original.fechaFormulario), "dd/MM/yyyy", {
            locale: es,
          })
          : "",
      Filter: ({ column, table }) => (
        <DatePicker
          locale={es}
          slotProps={{
            textField: {
              variant: "standard",
              sx: {
                "& .MuiInputBase-root": {
                  height: 35,
                },
                "& .MuiOutlinedInput-input ": {
                  height: 5,
                },
                "& .MuiChip-root": {
                  height: 1,
                },
              },
            },
          }}
          value={column.getFilterValue() || null}
          onChange={(newValue) =>
            table.setColumnFilters([{ id: column.id, value: newValue }])
          }
          renderInput={(params) => (
            <TextField {...params} variant="standard" />
          )}
        />
      ),
    },
    {
      header: "Fecha",
      accessorKey: "fechaError",

      enableColumnActions: false,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const cellValue = row.getValue(columnId);
        if (!cellValue) return false;
        return isSameDay(parseISO(cellValue), filterValue);
      },
      Cell: ({ row }) =>
        row.original.fechaError
          ? format(parseISO(row.original.fechaError), "dd/MM/yyyy", {
            locale: es,
          })
          : "",
      Filter: ({ column, table }) => (
        <DatePicker
          slotProps={{
            textField: {
              variant: "standard",
              sx: {
                "& .MuiInputBase-root": {
                  height: 35,
                },
                "& .MuiOutlinedInput-input ": {
                  height: 5,
                },
                "& .MuiChip-root": {
                  height: 1,
                },
              },
            },
          }}
          locale={es}
          value={column.getFilterValue() || null}
          onChange={(newValue) =>
            table.setColumnFilters([{ id: column.id, value: newValue }])
          }
          renderInput={(params) => (
            <TextField {...params} variant="standard" />
          )}
        />
      ),
    },
    {
      header: "Siniestro",
      enableColumnActions: false,
      accessorKey: "historiaClinica",
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },

    {
      header: "Documento",

      enableColumnActions: false,
      accessorKey: "documento",
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Trabajador",
      enableColumnActions: false,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          fontSize: 12,
          wordWrap: "break-word",
        },
      },
      accessorFn: (row) => {
        return row.trabajador;
      },

      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;

        const fullName = row.original.trabajador
          ? row.original.trabajador.replace(/\s+/g, " ").trim().toLowerCase()
          : "";

        return fullName.includes(filterValue.toLowerCase());
      },
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Empleador",
      accessorKey: "empleador",
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          fontSize: 12,
        },
      },
      enableColumnActions: false,
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minWidth: 100,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Formulario",
      accessorKey: "formulario",
      enableColumnActions: false,
      Cell: (rowData) => (
        <Box
          sx={{
            textAlign: "center",
          }}>
          {rowData.row.original.formulario}
        </Box>
      ),
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Detalle",
      enableColumnActions: false,
      accessorKey: "detalle",
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        const { detalle } = row.original;
        return detalle?.length > 40 ? (
          <Tooltip title={detalle} TransitionComponent={Zoom} arrow>
            <Typography
              variant="caption"
              sx={{
                whiteSpace: "normal", // Ajustar contenido en las celdas
                wordWrap: "break-word",
                fontSize: "0.80rem",
                // Ajusta el tamaño de la fuente de las celdas
              }}>
              {detalle.substring(0, 40)} <b>[...ver más]</b>
            </Typography>
          </Tooltip>
        ) : (
          <p>{detalle || ""}</p>
        );
      },
    },
    {
      id: "actions",
      header: "Acciones",
      accessorKey: "acciones",
      enableColumnFilter: false,
      enableColumnActions: false,
      enableSorting: false,
      sticky: "right",
      Cell: ({ row }) => (
        <div>
          <Tooltip title="Desestimar">
            <IconButton
              onClick={() => handleDesestimar(row.original)}
              color="inherit">
              <CancelOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar">
            <IconButton
              onClick={() => handleOpenEditForm(row.original)}
              color="inherit">
              <Edit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleExportToCsv = () => {
    setIsDownloadingCsv(true);
    dispatch(auditarExportacion(data, "mlCloudCoreArtId", CODIGO_AUDITORIA.EXPORTACION_CONECTIVIDAD))
      .then(() => {
        const encabezado = [
      "Art",
      "Fecha Formulario",
      "Fecha",
      "Siniestro",
      "Documento",
      "Trabajador",
      "Empleador",
      "Formulario",
      "Detalle",
    ];

    const formattedDataAsCsv = [encabezado, ...formatTableDataForExport(data)];

    let csvContent = "sep=,\n"; // Agregar separador para Excel
    csvContent += formattedDataAsCsv.map((row) => row.join(",")).join("\n");

    downloadCsv(csvContent, title);
    snackbarUtils.success("Los errores han sido descargados con éxito.");
    setIsDownloadingCsv(false);
      })
      .catch((error) => {
        snackbarUtils.error(error);
        setIsDownloadingCsv(false);
      });
  };

  const formatTableDataForExport = (table) => {
    return table.map((fila) => [
      fila.art ? `"${fila.art}"` : "",
      getFormatoFechaExportacion(fila.fechaFormulario, "dd/MM/yyyy"),
      getFormatoFechaExportacion(fila.fechaError, "dd/MM/yyyy"),
      fila.siniestro ? `"${fila.siniestro}"` : "",
      fila.documento ? `"${fila.documento}"` : "",
      `${fila.nombreTrabajador || ""} ${fila.apellidoTrabajador || ""}`.trim(),
      fila.empleador ? `"${fila.empleador}"` : "",
      fila.formulario ? `"${fila.formulario}"` : "",
      fila.detalle ? `"${fila.detalle}"`.trim() : "",
    ]);
  };

  return (
    <>
      <MaterialReactTable
        {...tableConfig}
        enableColumnActions={false}
        columns={columns}
        data={data}
        renderTopToolbarCustomActions={() => (
          <Box m={0.5}>
            <Box m={0.5} display="flex">
              <TitleContainer
                title={title}
                noRefresh={noRefresh}
                fetchData={fetchData}
              />
              <Tooltip title="Exportar CSV">
                <IconButton
                  color="inherit"
                  sx={{ margin: 2 }}
                  onClick={handleExportToCsv}>
                  <GetApp />
                </IconButton>
              </Tooltip>
            </Box>
            {time && (
              <div>
                <FormControl
                  sx={{ margin: 1, minWidth: 250 }}
                  variant="standard">
                  <InputLabel>Duración</InputLabel>
                  <Select onChange={handleChangeTime} value={time}>
                    <MenuItem value={2}>48 horas</MenuItem>
                    <MenuItem value={7}>7 días</MenuItem>
                    <MenuItem value={30}>30 días</MenuItem>
                    <MenuItem value={100}>100 días</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
          </Box>
        )}
        state={{ isLoading: loading || isDownloadingCsv }}
      />
    </>
  );
};

export default ConnectivityErrorsTable;
